import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import { getPageTitle } from "../../store/layoutUI";
import Menu from "../../../Components/Navigation/Menu";
import CandidateInfo from "../../components/CandidateInfo";
import PartnerInfo from "../../components/PartnerInfo";
import OnboardingSteps from "../../components/Onboarding/OnboardingSteps";
import EnrollmentSteps from "../../components/Onboarding/EnrollmentSteps";
import TopMenu from "../../components/TopMenu";

const HEADER_HEIGHT = 0;
const SIDE_NAV_WIDTH = 320;
const SIDE_NAV_COLLAPSED_WIDTH = 120;

const LAYOUT_STYLES = {
    page: {
        minHeight: "100vh",
        background: "linear-gradient(180deg, #f4f7fb 0%, #eef3f8 100%)",
        // overflowX: "hidden"
    },
    headerWrap: {
        width: "100%",
        //padding: "14px 0 12px 0",
        position: "relative",
        zIndex: 30
    },
    bodyWrap: {
        display: "block",
        width: "100%",
        boxSizing: "border-box"
    },
    contentWrap: {
        padding: "0px 10px 20px 10px",
        boxSizing: "border-box",
        minWidth: 0,
        maxWidth: "100%",
        overflowX: "hidden",
        width: "100%"
    },
    scrollArea: {
        height: `calc(100vh - ${HEADER_HEIGHT}px)`,
        overflowY: "auto",
        overflowX: "hidden",
        width: "100%",
        boxSizing: "border-box",
        minWidth: 0,
        paddingBottom: "300px"
    },
    canvas: {
        background: "linear-gradient(180deg, rgba(255,255,255,0.94) 0%, rgba(248,250,253,0.98) 100%)",
        border: "1px solid rgba(201, 210, 224, 0.65)",
        borderRadius: "22px",
        // boxShadow: "0 16px 42px rgba(31, 41, 55, 0.08)",
        overflow: "visible",
        marginTop: "18px",
        width: "100%",
        minWidth: 0,
        boxSizing: "border-box"
    },
    stack: {
        padding: "18px"
    },
    section: {
        marginBottom: "18px"
    },
    panel: {
        backgroundColor: "#ffffff",
        border: "1px solid rgba(214, 222, 235, 0.9)",
        borderRadius: "18px",
        boxShadow: "0 10px 28px rgba(15, 23, 42, 0.05)",
        overflow: "hidden"
    },
    contentPanel: {
        background: "linear-gradient(180deg, #ffffff 0%, #fbfcfe 100%)",
        border: "1px solid rgba(214, 222, 235, 0.95)",
        borderRadius: "20px",
        boxShadow: "0 14px 34px rgba(15, 23, 42, 0.06)",
        padding: "18px"
    }
};

const Layout = () => {
    const usrType = localStorage.getItem("userType");
    const pageTitleSelector = useSelector(getPageTitle);
    const [isMenuCollapsed, setIsMenuCollapsed] = useState(true);
    const showCollapsedRail = !isMenuCollapsed;

    useEffect(() => {
        const script = document.createElement("script");
        script.async = true;
        script.type = "text/javascript";
        script.src = "/assets/js/argon.js";
        document.body.appendChild(script);
    }, []);

    return <div className="main-content" id="panel" style={LAYOUT_STYLES.page}>
        <style>{`
                #sidenav-main {
                    // top: ${HEADER_HEIGHT}px;
                    left: 0;
                    width: ${showCollapsedRail ? SIDE_NAV_COLLAPSED_WIDTH : SIDE_NAV_WIDTH}px;
                    height: calc(100vh - ${HEADER_HEIGHT}px);
                    z-index: 20;
                    transition: width 0.2s ease;
                }

                #sidenav-main .sidenav-header {
                    display: flex !important;
                }

                #sidenav-main .navbar-inner {
                    margin-top: 0 !important;
                }
            `}</style>

        <h1 className="visually-hidden">{pageTitleSelector || "Application"}</h1>

        <div className="col-md-12 p-0" style={LAYOUT_STYLES.headerWrap}>
            <TopMenu />
        </div>

        <div
            style={{
                ...LAYOUT_STYLES.bodyWrap,
                paddingLeft: `${showCollapsedRail ? SIDE_NAV_COLLAPSED_WIDTH : SIDE_NAV_WIDTH}px`
            }}
        >
            <Menu
                isCollapsed={showCollapsedRail}
                onToggleCollapse={() => setIsMenuCollapsed((prev) => !prev)}
            />

            <div
                style={{
                    ...LAYOUT_STYLES.contentWrap
                }}
            >
                <div style={LAYOUT_STYLES.scrollArea}>
                    <div style={LAYOUT_STYLES.canvas}>
                        <div style={LAYOUT_STYLES.stack}>
                            <div style={LAYOUT_STYLES.section}>
                                <div style={LAYOUT_STYLES.panel}>
                                    {usrType === "candidate" ? <CandidateInfo /> : <PartnerInfo />}
                                </div>
                            </div>

                            <div style={LAYOUT_STYLES.section}>
                                {usrType === "candidate" ? <OnboardingSteps /> : <EnrollmentSteps />}
                                <Outlet />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
};

export default Layout;
